import BaseContainer from "@base/container/BaseContainer";
import * as PIXI from "pixi.js";
import LineAnimatedBackgroundContainer from "@/containers/LineAnimatedBackgroundContainer";

export default class GameBackgroundUpperContainer extends BaseContainer {

    constructor(data = null) {
        super(data)
        this.init(data)
    }

    init(data) {

        this.container = new PIXI.Container()
        this.addChild(this.container)

        const shadowFilter = new PIXI.filters.ColorMatrixFilter()
        shadowFilter.brightness(0.6, false)

        const blurFilter = new PIXI.filters.BlurFilter()
        blurFilter.blur = 0.5

        const hill2 = new LineAnimatedBackgroundContainer(['closeHill1', 'closeHill2', 'closeHill3', 'closeHill4', 'closeHill6', 'closeHill7', ], {
            speed: 15,
            sc: 1.2,
            delta: 600,
            coordinateArea :{ start: {x: -100, y: 590}, finish:{x:1300, y:590}},
            filters: [shadowFilter, blurFilter]
        })

        this.container.addChild(hill2)
    }

}
